import { render, staticRenderFns } from "./AddonsPage.vue?vue&type=template&id=ee99e116&scoped=true&"
import script from "./AddonsPage.vue?vue&type=script&lang=js&"
export * from "./AddonsPage.vue?vue&type=script&lang=js&"
import style0 from "./AddonsPage.vue?vue&type=style&index=0&id=ee99e116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee99e116",
  null
  
)

export default component.exports